/* Pop Advent – toont alleen lokale betaalmethoden op basis van het IP-land van de bezoeker */
(function () {
  var KEY = 'pa_ip_country';
  function data() {
    var el = document.querySelector('script.pa-pay-map');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function apply(cc, d) {
    var list = d.map[cc] || d.map.DEFAULT || [];
    document.querySelectorAll('ul').forEach(function (ul) {
      var items = [].slice.call(ul.querySelectorAll(':scope > li[data-pa-pay]'));
      if (!items.length) return;
      var shown = 0, anchor = ul.querySelector(':scope > li.pa-pay-data');
      list.forEach(function (t) {
        var li = items.filter(function (i) { return i.getAttribute('data-pa-pay') === t; })[0];
        if (li) { li.hidden = false; ul.insertBefore(li, anchor); shown++; }
      });
      items.forEach(function (li) {
        if (list.indexOf(li.getAttribute('data-pa-pay')) < 0) li.hidden = shown > 0;
      });
      ul.setAttribute('data-pa-country', cc);
    });
  }
  function run() {
    var d = data();
    if (!d) return;
    var use = function (cc) {
      cc = (cc || '').toUpperCase();
      // Alleen wisselen als het IP-land in een actieve markt zit; anders klopt de checkout niet met de iconen.
      if (cc && cc !== d.country && (!d.available.length || d.available.indexOf(cc) > -1)) apply(cc, d);
    };
    var cached = null;
    try { cached = sessionStorage.getItem(KEY); } catch (e) {}
    if (cached) return use(cached);
    fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var cc = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        if (!cc) return;
        try { sessionStorage.setItem(KEY, cc); } catch (e) {}
        use(cc);
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

/* Pop Advent – mobiele productgalerij: dots i.p.v. thumbnails */
(function () {
  function build(gallery) {
    var list = gallery.querySelector('ul.product__media-list');
    if (!list || gallery.querySelector('.pa-dots')) return;
    var slides = [].slice.call(list.querySelectorAll(':scope > li.product__media-item'));
    if (slides.length < 2) return;
    var dots = document.createElement('div');
    dots.className = 'pa-dots';
    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Image ' + (i + 1));
      b.addEventListener('click', function () { list.scrollTo({ left: s.offsetLeft - list.offsetLeft, behavior: 'smooth' }); });
      dots.appendChild(b);
    });
    var viewer = gallery.querySelector('slider-component[id^="GalleryViewer"]') || list.parentElement;
    viewer.insertAdjacentElement('afterend', dots);
    function update() {
      var visible = slides.filter(function (s) { return s.offsetParent !== null; });
      var x = list.scrollLeft, best = 0, d = Infinity;
      visible.forEach(function (s, i) { var dd = Math.abs(s.offsetLeft - list.offsetLeft - x); if (dd < d) { d = dd; best = slides.indexOf(s); } });
      [].forEach.call(dots.children, function (b, i) { b.classList.toggle('is-active', i === best); b.hidden = slides[i].offsetParent === null; });
    }
    list.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function run() { document.querySelectorAll('media-gallery').forEach(build); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

/* Pop Advent – quick add from cart recommendations */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pa-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true; btn.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer');
    var body = { id: Number(btn.getAttribute('data-pa-add')), quantity: 1 };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { btn.disabled = false; btn.classList.remove('is-loading'); btn.textContent = 'Indisponible'; return; }
      if (drawer && res.sections && typeof drawer.renderContents === 'function') { drawer.renderContents(res); }
      else { window.location.reload(); }
    }).catch(function () { window.location.reload(); });
  });
})();
